export const pricer = (value) => `$\u00A0${parseFloat(value || 0).toFixed(2)}`;
